import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const TransmittalRCE = () => {
  const faqs = [
    {
      question: "Q: What is the “RCE Transmittal” feature used for ?",
      answer:
        "A: The RCE Transmittal feature lets users generate Request for Continued Examination (RCE) transmittal forms efficiently.",
    },
    {
      question: "Q: What inputs are required for generating RCE Transmittal forms ?",
      answer:
        "A: You will need the application number(s), attorney name, and registration number, plus a response to the signature prompt.",
    },
    {
      question: "Q: In which format are the forms downloaded ?",
      answer:
        "A: Forms are generated in PDF format and can be edited using any standard PDF editor.",
    },
    {
      question: "Q: Where can I download the generated forms ?",
      answer:
        "A: Completed forms can be downloaded from the JUNE interface, or via an email link for larger requests.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default TransmittalRCE;
